export default __webpack_public_path__ + "static/media/meals_male@3x.65391ba9.png";